import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';


export const getTranslations = createAsyncThunk(
    '/Translation/Get',
    async (filter) => {
        const response = await axiosHeadOffice.get(`/Translation/Get/${filter.applicationName}/${filter.language}/${filter.translationEnv}`);
        return JSON.stringify(response.data, null, 2);
    }
);

export const getTranslationEnvironments = createAsyncThunk(
    '/Translation/GetEnvironments',
    async (filter) => {
        const response = await axiosHeadOffice.get(`/Translation/GetEnvironments/${filter.applicationName}/${filter.language}`);
        return response.data;
    }
);


export const syncToBackend = createAsyncThunk('/Translation/Sync', async (req) => {
    const response = await axiosHeadOffice.post(`/Translation/Sync`, req);
    return response.data;
});

export const getEnvironmentByUrl = createAsyncThunk(
    '/Translation/GetEnvByUrl',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axiosHeadOffice.get(`/Translation/GetEnvByUrl?Url=${params.url}&applicationId=${params.applicationId}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.data && error.response.data.Message) {
                return rejectWithValue(error.response.data.Message);
            } else if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);


let initFilter = {
    applicationName: '',
    language: '',
    translationEnv: ''
};


const translationSlice = createSlice({
    name: 'translation',
    initialState: {
        loading: false,
        translations: null,
        translationEnvironments: [],
        translationFilter: initFilter,
        isSyncing: false,
        syncStatus: '',
        urlAnalysis: {
            loading: false,
            result: null,
            error: null
        }
    },
    reducers: {
        setTranslationFilter: (state, action) => {
            const savedFilter = state.translationFilter;
            savedFilter[action.payload.name] = action.payload.value;
            state.translationFilter = { ...savedFilter, ...action.payload };
        },
        setTranslation: (state, action) => {
            state.translations = action.payload;

        }, setIsSyncing: (state, action) => {
            state.isSyncing = action.payload;
        }, clearUrlAnalysis: (state) => {
            if (!state.urlAnalysis) {
                state.urlAnalysis = { loading: false, result: null, error: null };
            }
            state.urlAnalysis.result = null;
            state.urlAnalysis.error = null;
        },
    },
    extraReducers: {
        [getTranslations.pending]: (state) => {
            state.loading = true;
        },
        [getTranslations.fulfilled]: (state, action) => {
            state.loading = false;
            state.translations = action.payload;
        },
        [getTranslations.rejected]: (state) => {
            state.loading = false;
        },
        [getTranslationEnvironments.pending]: (state) => {
            state.loading = true;
            state.syncStatus = 'pending';
        },
        [getTranslationEnvironments.fulfilled]: (state, action) => {
            state.loading = false;
            state.translationEnvironments = action.payload;
        },
        [getTranslationEnvironments.rejected]: (state) => {
            state.isSyncing = false;
        },
        [syncToBackend.pending]: (state) => {
            state.isSyncing = true;
            state.syncStatus = 'pending';
        },
        [syncToBackend.rejected]: (state) => {
            state.isSyncing = false;
            state.syncStatus = 'failed';
        }, [syncToBackend.fulfilled]: (state, action) => {
            state.isSyncing = false;
            state.syncStatus = 'synched';
        }, [getEnvironmentByUrl.pending]: (state) => {
            if (!state.urlAnalysis) {
                state.urlAnalysis = { loading: false, result: null, error: null };
            }
            state.urlAnalysis.loading = true;
            state.urlAnalysis.error = null;
        },
        [getEnvironmentByUrl.fulfilled]: (state, action) => {
            if (!state.urlAnalysis) {
                state.urlAnalysis = { loading: false, result: null, error: null };
            }
            state.urlAnalysis.loading = false;
            state.urlAnalysis.result = action.payload.Data;
            state.urlAnalysis.error = null;
        }, [getEnvironmentByUrl.rejected]: (state, action) => {
            if (!state.urlAnalysis) {
                state.urlAnalysis = { loading: false, result: null, error: null };
            }
            state.urlAnalysis.loading = false;
            state.urlAnalysis.error = action.payload || action.error.message;
        },
    }
});

export const translationActions = translationSlice.actions;

export default translationSlice;